// ============================================================
// Format helpers used throughout the admin UI
// ============================================================

export const fmtNumber = (n) => {
  if (n == null || isNaN(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (Math.abs(n) >= 1_000)     return (n / 1_000).toFixed(1) + 'k';
  return new Intl.NumberFormat('en-IN').format(n);
};

export const fmtPct = (n, digits = 1) => {
  if (n == null || isNaN(n)) return '—';
  return (n * 100).toFixed(digits) + '%';
};

export const fmtMs = (n) => {
  if (n == null || isNaN(n)) return '—';
  if (n < 1000) return Math.round(n) + ' ms';
  return (n / 1000).toFixed(2) + ' s';
};

export const fmtDate = (d, opts = {}) => {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date)) return '—';
  return date.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', hour12: true,
    ...opts,
  });
};

export const fmtDateShort = (d) => {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date)) return '—';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
};

export const fmtRelative = (d) => {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (isNaN(date)) return '—';
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60)        return 'just now';
  if (seconds < 3600)      return Math.floor(seconds / 60)   + 'm ago';
  if (seconds < 86_400)    return Math.floor(seconds / 3600) + 'h ago';
  if (seconds < 604_800)   return Math.floor(seconds / 86_400)+ 'd ago';
  return fmtDateShort(date);
};

// ============================================================
// Date range presets for analytics filters
// ============================================================

export const RANGE_PRESETS = {
  '24h': { label: 'Last 24 hours', hours: 24 },
  '7d':  { label: 'Last 7 days',   hours: 24 * 7 },
  '30d': { label: 'Last 30 days',  hours: 24 * 30 },
  '90d': { label: 'Last 90 days',  hours: 24 * 90 },
  'all': { label: 'All time',      hours: null },
};

export const rangeToParams = (key) => {
  const preset = RANGE_PRESETS[key];
  if (!preset || preset.hours == null) return {};
  const to = new Date();
  const from = new Date(Date.now() - preset.hours * 3600 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
};

// Given backend language code (en-IN/hi-IN/mr-IN), return human label
export const langLabel = (code) => {
  if (!code) return 'Unknown';
  const m = {
    'en-IN': 'English',
    'hi-IN': 'हिन्दी (Hindi)',
    'mr-IN': 'मराठी (Marathi)',
  };
  return m[code] || code;
};

// Theme/domain → display
const THEME_LABELS = {
  vaicharik: 'वैचारिक · Ideological',
  sangathana: 'सङ्गठन · Organisational',
  seva: 'सेवा · Service',
  shiksha: 'शिक्षा · Education',
  samajik_samarasta: 'सामाजिक समरसता · Social Harmony',
  rashtriya_suraksha: 'राष्ट्रीय सुरक्षा · National Security',
  sanskriti: 'संस्कृति · Culture',
  itihaas: 'इतिहास · History',
  general: 'general',
};
export const themeLabel = (key) => THEME_LABELS[key] || key;

// Saffron-on-paper palette tuned for charts
export const CHART_COLORS = [
  '#C26C1B', // saffron
  '#4A6741', // green
  '#8B4A10', // saffron deep
  '#B8932A', // gold
  '#A89789', // ink-300
  '#52443A', // ink-600
  '#BA1A1A', // red
  '#3A3128', // ink-700
];
